import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Parallax } from 'react-scroll-parallax';
import { Link as ScrollTo } from 'react-scroll';

const HeroSection = () => {
	return (
		<div className='h-[660px] lg:h-[580px] md:h-[550px] sm:h-[500px] xs:h-[380px] overflow-hidden relative'>
			<Parallax
				className='lg-no-parallax h-[100vh] w-full bg-cover bg-top cover-background absolute top-[0px] left-0 lg:h-[700px] lg:-top-[100px] md:h-[650px] sm:h-[550px] xs:h-[420px] xs:-top-[70px]'
				translateY={[-40, 40]}
				style={{
					backgroundImage: `url(assets/img/services/air-freight.jpg)`,
				}}
			/>

			<div className='absolute h-full w-full opacity-50 top-0 left-0 bg-darkgray'></div>
			<Container className='h-full relative xs:px-[15px]'>
				<Row className='justify-center h-full'>
					<Col
						xl={6}
						lg={7}
						md={8}
						className='relative font-serif text-center text-white flex justify-center flex-col'
					>
						<h1 className='opacity-60 mb-[20px] text-xmd leading-[20px]'>
							Worldwide Air Freight
						</h1>
						<h2 className='font-medium -tracking-[1px] mb-0'>
							Fast, reliable global air cargo
						</h2>
					</Col>
					<ScrollTo
						to='about'
						offset={0}
						delay={0}
						spy={true}
						smooth={true}
						duration={800}
						className='absolute bottom-[50px] left-1/2 w-auto inline-block -translate-x-1/2 cursor-pointer'
					>
						<i className='ti-arrow-down text-lg leading-none text-white bg-[rgba(0,0,0,0.7)] p-[15px] xs:p-[10px] rounded-full flex justify-center items-center'></i>
					</ScrollTo>
				</Row>
			</Container>
		</div>
	);
};

export default HeroSection;
